import React from 'react';
import ReactTooltip from 'react-tooltip';

const DEFAULTS: ReactTooltip.Props = {
  place: 'top',
  type: 'dark',
  effect: 'solid',
  globalEventOff: 'click',
  eventOff: 'click',
  delayShow: 1000,
};

export default function Tooltip(props: ReactTooltip.Props) {
  const { children, ...rest } = { ...DEFAULTS, props };

  return (
    <>
      { /* @ts-ignore This has issues with tsc and it's unclear why (tsc complains that it is missing required property refs) */ }
      <ReactTooltip {...rest}>
        {children}
      </ReactTooltip>
    </>
  );
}

Tooltip.rebuild = () => ReactTooltip.rebuild();
